import { privGetRequest } from "../vidCloud/priv";

const DocumentSnapshotService = {};
;

DocumentSnapshotService.getDocumentSnapshot = (doucmentGuid) => {
  return privGetRequest(`/documentsnapshot/${doucmentGuid}`);
}

export default DocumentSnapshotService;